<div class="col-md-12">
  <div class="row">
    <div class="col-md-7" style="padding-left:6%;">
      <div class="toolbar-section" id="account">
        <ul class="nav nav-tabs nav-justified" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="#login" data-bs-toggle="tab" role="tab">{{'Temple'|translate}} Owner Log In</a>
          </li>
          <li class="nav-item">
            <a class="nav-link " href="#signup" data-bs-toggle="tab" role="tab">{{'Temple'|translate}} Owner Sign Up</a>
          </li>
        </ul>
        <div class="tab-content">
          <div class="tab-pane fade show active" id="login" role="tabpanel">
             <form autocomplete="off"  autocomplete="off" id="login-form">
              <div class="mb-3 input-group">
                <input class="form-control" type="email" placeholder="{{'Email'|translate}}" required>
                <span class="input-group-addon">
                  <i class="material-icons mail"></i>
                </span>
              </div>
              <div class="mb-3 input-group">
                <input class="form-control" type="password" placeholder="{{'Password'|translate}}" required>
                <span class="input-group-addon">
                  <i class="material-icons lock"></i>
                </span>
              </div>
              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" id="logged" checked>
                <label class="form-check-label" for="logged">Keep me logged in</label>
              </div>
              <div style="padding-left:45%;">
                <button class="btn btn-primary" >Log In</button>
              </div>
              <p class="text-muted text-sm mt-4" style="text-align: center;">OR log in with your social account</p>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3" (click)="faceBookLogin()">
                    <a class="media-btn d-flex-facebook">
                      <i class="socicon-facebook"></i>
                      <span>Signup with Facebook</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="col-md-3">
                    <a class="media-btn d-flex-google">
                      <i class="socicon-googleplus"></i>
                      <span>Signup with Google+</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="col-md-3">
                    <a class="media-btn d-flex-twitter">
                      <i class="socicon-twitter"></i>
                      <span>Signup with Twitter</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane fade show " id="signup" role="tabpanel">
             <form autocomplete="off"  autocomplete="off" id="signup-form">
              <div class="mb-3">
                <input class="form-control" type="text" placeholder="temple {{'Name'|translate}}" required>
              </div>
              <div class="mb-3">
                <select class="form-control" >
                  <option>Main {{'Deity'|translate}}</option>
                  <option>Option item 1</option>
                  <option>Option item 2</option>
                  <option>Option item 3</option>
                </select>
              </div>
              <div class="mb-3">
                <input class="form-control" type="text" placeholder="{{'Account'|translate}} {{'Number'|translate}}" required>
              </div>
              <div style="padding-left:45%;">
                <button class="btn btn-primary " >Sign Up</button>
              </div>
              <p class="text-muted text-sm mt-4" style="text-align: center;">OR sign up with your social account</p>

              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-3" (click)="faceBookLogin()">
                    <a class="media-btn d-flex-facebook">
                      <i class="socicon-facebook"></i>
                      <span>Signup with Facebook</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="col-md-3">
                    <a class="media-btn d-flex-google">
                      <i class="socicon-googleplus"></i>
                      <span>Signup with Google+</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div class="col-md-3">
                    <a class="media-btn d-flex-twitter">
                      <i class="socicon-twitter"></i>
                      <span>Signup with Twitter</span>
                    </a>
                  </div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5" style="padding-left:25%;">
      <button class="btn btn-primary pull-right" routerLink="/app/login">{{'Devotee'|translate}} Portal</button>
    </div>
  </div>
</div>